import { INhomCauHoiProgressRequest } from "../../model/request/nhom-cau-hoi/INhomCauHoiProgressRequest";
import { ISMT_NhomCauHoi } from "../../model/respone/cau-hoi/ISMT_NhomCauHoi";
import { ISMT_NhomCauHoi_MucTriNang } from "../../model/respone/cau-hoi/ISMT_NhomCauHoi_MucTriNang";
import { apiClient } from "../apiClient";
export const NHOM_CAU_HOI_ENDPOINT = "nhom-cau-hoi";
export const nhomCauHoiApi = {
  SelectAll: () => apiClient.get(`${NHOM_CAU_HOI_ENDPOINT}`),
  SelectVmAll: () => apiClient.get(`${NHOM_CAU_HOI_ENDPOINT}/select-vm-all`),
  SelectById: (id: number) => apiClient.get(`${NHOM_CAU_HOI_ENDPOINT}/${id}`),
  SelectIdNhomCauHoi: (id_he: number, id_mon: number) =>
    apiClient.get(
      `${NHOM_CAU_HOI_ENDPOINT}/select-id-nhom-cau-hoi/${id_he}/${id_mon}`
    ),
  Insert: (payload: ISMT_NhomCauHoi) =>
    apiClient.post(`${NHOM_CAU_HOI_ENDPOINT}`, payload),
  Update: (payload: ISMT_NhomCauHoi) =>
    apiClient.put(`${NHOM_CAU_HOI_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${NHOM_CAU_HOI_ENDPOINT}/${id}`),
  Import: (data: FormData) =>
    apiClient.upload(`${NHOM_CAU_HOI_ENDPOINT}/import`, data),

  InsertMucTriNang: (payload: ISMT_NhomCauHoi_MucTriNang[]) =>
    apiClient.post(`${NHOM_CAU_HOI_ENDPOINT}/muc-tri-nang-inserts`, payload),
  DeleteMucTriNang: (id: number) =>
    apiClient.delete(`${NHOM_CAU_HOI_ENDPOINT}/muc-tri-nang-delete/${id}`),
  DeleteBoCauHoi: (payload: any) =>
    apiClient.put(`${NHOM_CAU_HOI_ENDPOINT}/bo-cau-hoi-delete/`, payload),

  Progress: (payload: INhomCauHoiProgressRequest) =>
    apiClient.post(`${NHOM_CAU_HOI_ENDPOINT}/progress`, payload),
};
